import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  loader:{
    background: 'rgba(255, 255, 255, 0.7)',
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 99999,
  },
  img: {
    position: 'fixed',
    width: '50px',
    height: 'auto',
  },
  loaderContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  message: {
    // color: '#03997B',
    color:'#02906f',
    fontWeight: 600,
    marginTop: '14px',
    textAlign: 'center',
    fontSize: '16px !important',
  },
}));
export default useStyles;
